import { gql } from "@apollo/client";

export const QUERY_LOOKUP_BARCODE = gql`
  query LookupBarcode($input: BarcodeLookupInput!) {
    lookupBarcode(input: $input) {
      ... on ProductFoundResult {
        result
        product {
          name
          description
        }
      }
      ... on InvalidBarcodeLookupCredentialsError {
        errorCode
        message
      }
      ... on InsufficientBarcodeLookupCreditsError {
        errorCode
        message
      }
    }
  }
`;
